import axios from 'axios';

const REFRESH_AUTH_TOKEN_PATH = '/api/v1/auth_token/refresh';

export const refreshAuthToken = () => {
    const token = window.localStorage.getItem('jwt');
    return axios({
        method: 'post',
        url: `${process.env.API_HOST}${REFRESH_AUTH_TOKEN_PATH}`,
        data: {},
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
        },
    }).then((res) => {
        if (!res || res.status !== 200) {
            throw new Error('Invalid session');
        }

        return res.data;
    }).catch((_error) => {
        throw new Error('Invalid session');
    });
};
